import type { FC } from 'react';

import { FullPageContent } from '@/components/layout/full-page-content';
import { Dashboard } from '@/components/looker/dashboard';

export const AlertsExportPage: FC = () => {
  return (
    <FullPageContent>
      <Dashboard id="overview" />
    </FullPageContent>
  );
};
